import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'advantagelogdisplay',
  pure : false
})
export class AdvantageLogDisplay implements PipeTransform {

  transform( stringValue:string): any {
    let displayValue;
    if(!stringValue) {displayValue = stringValue;}
    else if (parseFloat(stringValue).toFixed(2) == 'NaN'){
      let splittedValue = (stringValue.toString()).split('[');
      if(splittedValue && splittedValue.length > 1) {
          let convertedValue = splittedValue
          .map(x=> x.split('['))
          .map((x,index)=> {if(index != 0) return `\n[${x}`} )
          .join(' ');
          displayValue = convertedValue;
      } else {
          displayValue = stringValue;
      }
    } else {
      displayValue = parseFloat(stringValue).toFixed(2);
    }

    return displayValue;
   }
}